import { useEffect, useState } from 'react'
import { FieldValues, UseFormSetValue } from 'react-hook-form'

import { Box, Stack, Typography } from '@mui/material'
import { DataService } from 'api/DataService'
import CategoryForm from 'templates/AccountsPayable/components/ConfigurationDrawer/Steps/CategoryForm'

import AutocompleteAdd from 'components/AutocompleteAdd/AutocompleteAdd'

type Record = {
  label: string
  value: string
  color: string
}

type CategoryAutocompleteProps<T extends FieldValues> = {
  setValue?: UseFormSetValue<T>
  value: Omit<Record, 'color'> | null
  onChange: any
  errorMessage: string
  showAddButton?: boolean
}

const CategoryAutocomplete = <T extends FieldValues>({
  value,
  onChange,
  errorMessage = '',
  setValue,
  showAddButton = true
}: CategoryAutocompleteProps<T>) => {
  const [categories, setCategories] = useState<any[]>()
  // Incrementa depois de criar um item novo pelo "Adicionar", pra lista ser rebuscada
  const [reloadKey, setReloadKey] = useState(0)

  useEffect(() => {
    const fetchCategoriesAutocomplete = async () => {
      const response = await DataService({
        type: 'GET',
        url: '/v1/accounts_payables/categories/autocomplete'
      })

      setCategories(
        response.data.records.map(
          (category: { name: any; uuid: any; color: any }) => ({
            label: category.name,
            value: category.uuid,
            color: category.color
          })
        )
      )
    }

    fetchCategoriesAutocomplete()
  }, [reloadKey])

  return (
    <>
      <AutocompleteAdd
        showAddButton={showAddButton}
        addPermission="accounts_payable:manage"
        key={value?.value}
        {...{ value, onChange, setValue, errorMessage }}
        addButtonText="Adicionar categoria"
        label="Categoria *"
        placeholder="Selecione a categoria"
        modalTitle="Nova categoria"
        options={categories || []}
        renderOption={(props, option) => {
          const optionTyped = option as Record
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { style, ...rest } = props

          return (
            <Box component="li" sx={{ all: 'unset' }} {...rest}>
              <Stack direction="row" alignItems="center" gap="15px" py={1}>
                <Box
                  sx={{
                    height: '9px',
                    width: '9px',
                    bgcolor: `#${optionTyped.color}`,
                    borderRadius: '999px'
                  }}
                ></Box>
                <Typography>{optionTyped.label}</Typography>
              </Stack>
            </Box>
          )
        }}
        modalBodyComponent={
          <CategoryForm
            onCreated={(item) => {
              // seleciona o item novo no campo de quem usa o autocomplete
              onChange(null, { label: item.name, value: item.uuid })
              setReloadKey((key) => key + 1)
            }}
            handleClose={() => {
              return
            }}
          />
        }
      />
    </>
  )
}

export default CategoryAutocomplete
